window.addEventListener('DOMContentLoaded', () => {
    const $videoElements = document.querySelectorAll('.cmp-video');

    Array.from($videoElements).forEach(($element) => {
        const $playButton = $element.querySelector<HTMLAnchorElement>(".cmp-video_play-button");
        const $videoImage = $element.querySelector<HTMLAnchorElement>(".cmp-video_image");
        const $video = $element.querySelector<HTMLAnchorElement>(".cmp-video_video");
        const $videoIframe = $element.querySelector<HTMLAnchorElement>(".cmp-video_video iframe");
        const $parentElement = $element.closest('.cmp-video-card');

        if ($playButton) {
            $playButton.addEventListener("click", (e) => {
                e.preventDefault();

                $videoImage?.classList.add('cmp-video_image--hidden');
                $video?.classList.remove('cmp-video_video--hidden');

                const videoId = $element.dataset["video_id"];
                $videoIframe?.setAttribute('src', `https://www.youtube.com/embed/${ videoId }?autoplay=1`);

                // Notify parent that video has started playing if relevant (ie matches $parentElement selector)
                if ($parentElement) {
                    $parentElement.classList.add('video-playing');
                }
            });
        }
    });
});